<template>
    <div class="companies-view">
        <section class="companies-landing --socialpath">
            <div class="comp-logo"><img width="150px" src="../assets/imgs/icons/global-choices-logo-white.png"></div>
            <div class="intro-hd-container">
                <img src="../assets/imgs/icons/social-path-chat.png">
                <img src="../assets/imgs/icons/social-path-white.png">
                 
                <p class="content-text --justify">
                    Social Path is a digital marketing agency that specialises in P2P marketing. Through our use of contagious marketing we strive to always give measurable ROI. Our social shake up began when we kept hearing people mention that they were either B2B or B2C. By using authentic words to meet specific business objectives we look to give you quality traffic that converts to quality leads for a real return on investment made by your brand.</p>
                <button class="btn comps-btn">ENGAGE WITH YOUR AUDIENCE</button>
            </div>

            <div class="social-icons-mobile">
                <ul class="social-items">
                    <li><a href="" class="facebook"></a></li>
                    <li><a href="" class="twitter"></a></li>
                    <li><a href="" class="linkedin"></a></li>
                    <li><a href="" class="instagram"></a></li>
                    <li><a href="" class="youtube"></a></li>
                </ul>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    
}
</script>

<style>

</style>
